import React from 'react';
import './Header.css';

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  return (
    <header className="app-header">
      <div className="header-content">
        <button className="menu-button" onClick={onMenuClick} aria-label="Ouvrir le menu">
          <span className="menu-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </span>
        </button>
        <div className="header-titles">
          <h1 className="app-title">La Carte Littéraire</h1>
          <span className="header-subtitle">Parcours narratif &middot; Saint-Jérôme</span>
        </div>
      </div>
    </header>
  );
};

export default Header;
